import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { reportLocationsEnum, reportProvidersEnum } from '@modules/reports/_reportsEnums';

export default [
  {
    label: 'Jméno',
    field: 'name',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Popis',
    field: 'label',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Třída poskytovatele',
    field: 'provider',
    displayField: 'provider',
    type: ColumnType.ENUM,
    enum: reportProvidersEnum,
    width: 200
  },
  {
    label: 'Lokace',
    field: 'location.id',
    displayField: 'location',
    type: ColumnType.ENUM,
    enum: reportLocationsEnum,
    width: 200
  },
  {
    label: 'Jméno souboru',
    field: 'fileName',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Vytvořeno',
    field: 'created',
    align: 'left',
    type: ColumnType.DATE,
    width: 100
  }
];



// WEBPACK FOOTER //
// ./src/modules/reports/_reportsColumns.ts